import Vue from "vue";
import App from "./App.vue";
import VueScrollTo from "vue-scrollto";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import AOS from "aos";
import "aos/dist/aos.css";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import Vue2Filters from "vue2-filters";
import axios from "axios";
import { detect } from "detect-browser";
import store from "./store";
import router from "./router/index.js";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

library.add(faSpinner);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

Vue.use(BootstrapVue);

Vue.use(VueSweetalert2);

Vue.use(Vue2Filters);

Vue.filter("toCurrency", function(value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return formatter.format(value);
});

// Browser Detection
axios
  .post(process.env.VUE_APP_BASE_URL + "/api/router/Tracking.php", {
    action: "tracking",
    prefix: "broncos2025extension_tracking",
    label: `browser/${detect().name}`,
  })
  .catch(() => {
    window.console.log("failed tracking");
  });

Vue.directive("ePitchTracking", {
  bind(el, binding) {
    const label = binding.value;

    el.addEventListener("click", () => {
      axios
        .post(process.env.VUE_APP_BASE_URL + "/api/router/Tracking.php", {
          action: "tracking",
          prefix: "broncos2025extension_tracking",
          label,
        })
        .catch(() => {
          window.console.log("failed tracking");
        });
      window.console.log(label);
    });
  },
});

new Vue({
  store,
  created() {
    AOS.init();
    this.$store.dispatch("fetchUserInfo", {
      router: this.$router,
    });
  },
  router,
  render: (h) => h(App),
}).$mount("#app");
